/* eslint-disable */
// @ts-ignore
export const exhaustiveCheck = (param: never): void => {}
